module.exports = __webpack_public_path__ + "img/g0103.e118893d.png";